module.exports = ".loader {\n  margin: 0 0 2em;\n  height: 100px;\n  width: 20%;\n  text-align: center;\n  padding: 1em;\n  margin: 0 auto 1em;\n  vertical-align: top; }\n\nsvg path,\nsvg rect {\n  fill: #FF6700; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading-indicator/loading-indicator.component.scss
// module id = ./src/app/components/loading-indicator/loading-indicator.component.scss
// module chunks = main